// --------------------------------------------------------------
// Created On: 2025-03-21
// Author: Dimitra Weinstein
//
// Last Modified: 2026-03-31
// Modified By: Dimitra Weinstein
//
// Copyright 2025 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment } from "react";

// A form to collect asset details for a Lift Station report.
export default function AssetDetailsForm(props: Props): Component {
  return (
    <div className="mx-1">
      <label className="mb-1">Asset Name</label>
      <input
        data-test="report-modal-asset-name-input"
        className="form-control mx-auto mb-3"
        type="text"
        list="datalist-assets"
        maxLength={50}
        value={props.assetName}
        disabled={props.disabled}
        onChange={(e) => props.onAssetNameChange(e.target.value)}
      />

      <label className="mb-1">Number of Pumps</label>
      <select
        data-test="report-modal-pump-number-select"
        className="form-select mx-auto mb-3"
        value={props.numberOfPumps}
        onChange={(e) => props.onNumberOfPumpsChange(parseInt(e.target.value))}
      >
        <option value="0" disabled>
          Please select the number of pumps...
        </option>
        <option value="1">One pump</option>
        <option value="2">Two pumps</option>
      </select>

      {props.numberOfPumps >= 1 && (
        <Fragment>
          <label className="mb-1">Pump #1 Capacity of Pump (gpm)</label>
          <input
            data-test="report-modal-pump-capacity-one-input"
            className="form-control mx-auto mb-3"
            type="text"
            placeholder="0.0"
            maxLength={50}
            value={props.capacityOfPrimaryPump !== null ? props.capacityOfPrimaryPump : ""}
            disabled={props.disabled}
            onChange={(e) => props.onCapacityOfPrimaryPumpChange(e.target.value)}
          />
        </Fragment>
      )}

      {props.numberOfPumps === 2 && (
        <Fragment>
          <label className="mb-1">Pump #2 Capacity of Pump (gpm)</label>
          <input
            data-test="report-modal-pump-capacity-two-input"
            className="form-control mx-auto mb-3"
            type="text"
            placeholder="0.0"
            maxLength={50}
            value={props.capacityOfSecondaryPump !== null ? props.capacityOfSecondaryPump : ""}
            disabled={props.disabled}
            onChange={(e) => props.onCapacityOfSecondaryPumpChange(e.target.value)}
          />
        </Fragment>
      )}
    </div>
  );
}

interface Props {
  disabled: boolean;
  assetName: string;
  numberOfPumps: number;
  capacityOfPrimaryPump: string | null;
  capacityOfSecondaryPump: string | null;
  onAssetNameChange: (value: string) => void;
  onNumberOfPumpsChange: (value: number) => void;
  onCapacityOfPrimaryPumpChange: (value: string) => void;
  onCapacityOfSecondaryPumpChange: (value: string) => void;
}
